const initializeDcMarquees = (scope = document) => {
  scope.querySelectorAll('[data-dc-marquee="true"]').forEach((root) => {
    if (root.dataset.dcMarqueeInitialized === 'true') return;
    root.dataset.dcMarqueeInitialized = 'true';

    const viewport = root.querySelector('[data-dc-marquee-track]');
    const content = root.querySelector('[data-dc-marquee-content]');
    if (!viewport || !content) return;

    const existingDuplicate = root.querySelector('[data-dc-marquee-duplicate]');
    if (!existingDuplicate) {
      const duplicate = content.cloneNode(true);
      duplicate.dataset.dcMarqueeDuplicate = '';
      duplicate.setAttribute('aria-hidden', 'true');
      duplicate.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
      viewport.appendChild(duplicate);
    } else {
      existingDuplicate.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
    }

    viewport.classList.add('is-ready');
  });
};

document.addEventListener('DOMContentLoaded', () => initializeDcMarquees());
document.addEventListener('shopify:section:load', (event) => initializeDcMarquees(event.target));
